import p from './login.vue';

export default p;
